<template>
  <TransparentCard container-tag="section" container-class="achievments_prof col_3">
    <div class="title">
      <div class="left">
        <BaseImage
          src="/static/images/profile_ach.svg"
          alt="Levels"
        />
      </div>

      <div class="right">
        <h1>{{ $_translations.value.page_profile_overview_section_levels_title }}</h1>

        <p v-if="hasLevels">
          <span>{{ totalUnlockedLevels }}</span> / {{ levelStore.totalLevels }}
          {{ $_translations.value.page_profile_overview_section_levels_subtitle }}
        </p>
      </div>
    </div>

    <div class="achievement_badges levels">
      <LevelBadgeItem
        v-for="item in levelStore.levelList"
        :key="item.level"
        :item="item"
        @show:levelDetails="handleShowLevelDetails(item)"
      />
    </div>
  </TransparentCard>

  <LevelModal
    v-if="isLevelModalOpen"
    :data="selectedLevel"
    @start:game="handleStartGame"
    @redirect:storePage="handleRedirectToStorePage"
  />

  <PreGameSection
    v-else-if="isPreGameVisible"
    @hide:preGame="hidePreGame"
  />

</template>

<script setup>
import { computed, ref } from 'vue';
import TransparentCard from '@/components/card/TransparentCard.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import LevelBadgeItem from '@/views/profileOverview/components/item/LevelBadgeItem.vue';
import LevelModal from '@/components/modal/level/LevelModal.vue';
import useAuthStore from '@/store/modules/auth.js';
import useLevelStore from '@/store/modules/level.js';
import usePageNavigationHook from '@/hooks/usePageNavigation.js';
import useModalHook from '@/hooks/useModal.js';
import usePreGameHook from '@/hooks/usePreGame.js';
import PreGameSection from '@/components/section/PreGameSection.vue';

const { redirectToStorePage } = usePageNavigationHook();
const [isLevelModalOpen, openLevelModal, closeLevelModal] = useModalHook();
const { isPreGameVisible, launchNewGameFlow, hidePreGame } = usePreGameHook();

const authStore = useAuthStore();
const levelStore = useLevelStore();

const selectedLevel = ref(null);

const totalUnlockedLevels = computed(() => authStore.user.level);

const hasLevels = computed(() => levelStore.totalLevels > 0);

const resetModal = () => {
  selectedLevel.value = null;
};

const handleShowLevelDetails = (level) => {
  selectedLevel.value = level;

  openLevelModal({ afterHideCallback: resetModal });
};

const handleStartGame = () => {
  closeLevelModal({
    immediate: true,
    type: 'useCallback',
    afterHideCallback: () => {
      resetModal();
      launchNewGameFlow();
    },
  });
};

const handleRedirectToStorePage = () => {
  closeLevelModal({
    immediate: true,
    type: 'useCallback',
    afterHideCallback: () => {
      resetModal();

      redirectToStorePage();
    },
  });
};
</script>
